import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/admin/dashboard/ManagePackages.css';
import AdminLayout from '../../../../layouts/admin/AdminLayout';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

/* ── Available Services ── */
const APM_SERVICES = [
  
  { id: 'decoration',    label: 'Decoration',           icon: '🎨' },
  { id: 'photography',   label: 'Photography',          icon: '📸' },
  { id: 'videography',   label: 'Videography',          icon: '📹' },
  { id: 'music_dj',      label: 'Music & DJ',           icon: '🎵' },
  { id: 'lighting',      label: 'Lighting Setup',       icon: '💡' },
  { id: 'floral',        label: 'Floral Arrangements',  icon: '🌸' },
  { id: 'stage setup',        label: 'Stage Setup',  icon: '🌸' },
  
  
  
  
];

/* ── Fallback Venues (agar backend se na aayein) ── */
const APM_VENUES_FALLBACK = [
  'Pearl Continental Hotel',
  'Marquee Hall',
  'Royal Palace',
  'Garden Venue',
  'Grand Ballroom',
  'Beach Resort',
  'Country Club',
];

const APM_PER_PAGE = 5;

/* ── Helper: features ko hamesha array banao ── */
const toFeaturesArray = (features) => {
  if (!features) return [];
  if (Array.isArray(features)) return features.filter(f => f.trim() !== '');
  if (typeof features === 'string') return features.split(',').map(f => f.trim()).filter(f => f !== '');
  return [];
};

// ✅ FIX: services bhi features jaisa hi handle karna hai — backend
// createPackage/updatePackage mein JSON.stringify(Services) se ek STRING
// save hoti hai, aur viewAllPackages usi string ko raw wapas bhejta hai
// (array mein decode nahi karta). Pehle sirf `Array.isArray(pkg.services)`
// check ho raha tha jo string ke liye hamesha false deta — isliye Edit modal
// ke checkboxes aur View modal hamesha khaali dikhte the, chahe database
// mein services save ho chuki hon.
const toServicesArray = (services) => {
  if (!services) return [];
  if (Array.isArray(services)) return services;
  if (typeof services === 'string') {
    try {
      const parsed = JSON.parse(services);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return services.split(',').map(s => s.trim()).filter(Boolean);
    }
  }
  return [];
};

/* ── Helper: number ko comma-separated format mein dikhao (e.g. 150000 -> 150,000) ── */
const formatCurrency = (value) => {
  if (value === null || value === undefined) return '0';
  if (value === '') return '';
  const num = Number(String(value).replace(/,/g, ''));
  if (isNaN(num)) return value;
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

const ManagePackages = () => {

  const { baseUrl, regexChecker } = useContext(AppContext);

  const [Name,         setName]         = useState('');
  const [Price,        setPrice]        = useState('');
  const [Capacity,     setCapacity]     = useState('');
  const [Status,       setStatus]       = useState('Active');
  const [Description,  setDescription]  = useState('');
  const [Features,     setFeatures]     = useState('');
  const [Venue,        setVenue]        = useState('');
  const [Discount,     setDiscount]     = useState('');
  const [PackagePrice, setPackagePrice] = useState('');
  const [Services,     setServices]     = useState([]);

  // ===================== FORM VALIDATION ERRORS (regexChecker based) =====================
  const [packageErrors, setPackageErrors] = useState({
    name: '',
    price: '',
    discount: '',
    packagePrice: ''
  });

  const [packages,     setPackages]     = useState([]);
  const [venues,       setVenues]       = useState([]);          // ← backend se venues
  const [isLoading,    setIsLoading]    = useState(false);
  const [pageLoading,  setPageLoading]  = useState(true);
  const [apmSearch,    setApmSearch]    = useState('');
  const [apmStatus,    setApmStatus]    = useState('All');
  const [apmPage,      setApmPage]      = useState(1);
  const [sgcShowAdd,   setSgcShowAdd]   = useState(false);
  const [sgcShowEdit,  setSgcShowEdit]  = useState(false);
  const [sgcShowView,  setSgcShowView]  = useState(false);
  const [sgcEditData,  setSgcEditData]  = useState({});
  const [sgcViewData,  setSgcViewData]  = useState({});
  const [apmDeleteId,  setApmDeleteId]  = useState(null);

  // ── NEW: loading state for Add New Package button ──
  const [addBtnLoading, setAddBtnLoading] = useState(false);

  /* ── Venues backend se fetch karo ── */
  const fetchVenues = () => {
    axios
      .get(`${baseUrl}/admin/venue/viewAllVenue`)
      .then((res) => {
        const data = res.data;
        // Backend response ke mutabiq adjust karo
        // Agar response mein array of objects hai (e.g. [{id, name}, ...])
        const list = Array.isArray(data)
          ? data
          : data.venues ?? data.data ?? [];

        if (list.length > 0) {
          setVenues(list);
        } else {
          // Agar backend se kuch nahi aaya toh fallback use karo
          setVenues(APM_VENUES_FALLBACK.map((v, i) => ({ id: i, name: v })));
        }
      })
      .catch(() => {
        // Error pe fallback static list
        setVenues(APM_VENUES_FALLBACK.map((v, i) => ({ id: i, name: v })));
      });
  };

  const viewAllPackages = () => {
    axios
      .get(`${baseUrl}/admin/packages/viewAllPackages`)
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data) ? data : data.packages ?? data.data ?? [];
        const mapped = list.map(p => ({
          ...p,
          name:  p.name  || p.packageName || '',
          venue: p.venue || p.venue_id    || '',
        }));
        setPackages(mapped);
        setPageLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPageLoading(false);
      });
  };

  useEffect(() => {
    viewAllPackages();
    fetchVenues();          // ← Component mount pe venues bhi fetch karo
  }, []);

  // ===================== AUTO-CALCULATE Package Price (Original Price - Discount%) =====================
  useEffect(() => {
    const priceNum = Number(Price);
    const discountNum = Number(Discount);

    if (Price === '' || isNaN(priceNum)) {
      setPackagePrice('');
      return;
    }

    if (Discount === '' || isNaN(discountNum)) {
      setPackagePrice(String(priceNum));
      return;
    }

    const calculated = priceNum - (priceNum * discountNum / 100);
    setPackagePrice(String(Math.round(calculated * 100) / 100));
  }, [Price, Discount]);

  // ===================== VALIDATION (required + format, same style as MyEvents) =====================
  const resetPackageErrors = () => {
    setPackageErrors({
      name: '',
      price: '',
      discount: '',
      packagePrice: ''
    });
  };

  const validatePackageForm = () => {
    const errors = {
      name:         Name.trim() ? regexChecker('eventName', Name) : 'Package Name is required',
      price:        Price ? regexChecker('budget', Price) : 'Original Price is required',
      discount:     Discount ? regexChecker('budget', Discount) : '',
      packagePrice: PackagePrice ? regexChecker('budget', PackagePrice) : ''
    };

    setPackageErrors(errors);

    return Object.values(errors).some((err) => err);
  };

  const createPackage = () => {
    const hasErrors = validatePackageForm();
    if (hasErrors) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append('name',         Name);
    formData.append('price',        Price);
    formData.append('capacity',     Capacity);
    formData.append('status',       Status);
    formData.append('description',  Description);
    formData.append('features',     Features);
    formData.append('venue',        Venue);
    formData.append('discount',     Discount);
    formData.append('packagePrice', PackagePrice);
    formData.append('services',     JSON.stringify(Services));

    axios
      .post(`${baseUrl}/admin/packages/createPackage`, formData)
      .then(() => {
        viewAllPackages();
        setSgcShowAdd(false);
        setName(''); setPrice(''); setCapacity(''); setStatus('Active');
        setDescription(''); setFeatures(''); setVenue('');
        setDiscount(''); setPackagePrice(''); setServices([]);
        resetPackageErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const updatePackage = () => {
    const hasErrors = validatePackageForm();
    if (hasErrors) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append('id',           sgcEditData.id);
    formData.append('name',         Name);
    formData.append('price',        Price);
    formData.append('capacity',     Capacity);
    formData.append('status',       Status);
    formData.append('description',  Description);
    formData.append('features',     Features);
    formData.append('venue',        Venue);
    formData.append('discount',     Discount);
    formData.append('packagePrice', PackagePrice);
    formData.append('services',     JSON.stringify(Services));

    axios
      .post(`${baseUrl}/admin/packages/updatePackage`, formData)
      .then(() => {
        viewAllPackages();
        setSgcShowEdit(false);
        setName(''); setPrice(''); setCapacity(''); setStatus('Active');
        setDescription(''); setFeatures(''); setVenue('');
        setDiscount(''); setPackagePrice(''); setServices([]);
        resetPackageErrors();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const deletePackage = (id) => {
    axios
      .delete(`${baseUrl}/admin/packages/deletePackage/${id}`)
      .then(() => {
        viewAllPackages();
        setApmDeleteId(null);
      })
      .catch((err) => console.log(err));
  };

  const sgcOpenAdd = () => {
    resetPackageErrors();
    setSgcShowAdd(true);
  };

  // ── NEW: Add New Package button ab loading dikhata hai phir modal khulta hai ──
  const handleAddPackageClick = () => {
    setAddBtnLoading(true);
    setTimeout(() => {
      sgcOpenAdd();
      setAddBtnLoading(false);
    }, 600);
  };

  const sgcOpenEdit = (pkg) => {
    setSgcEditData(pkg);
    setName(pkg.name);
    setPrice(pkg.price);
    setCapacity(pkg.capacity);
    setStatus(pkg.status);
    setDescription(pkg.description);
    setFeatures(Array.isArray(pkg.features) ? pkg.features.join(', ') : pkg.features);
    setVenue(pkg.venue || '');
    setDiscount(pkg.discount || '');
    setPackagePrice(pkg.packagePrice || '');
    setServices(toServicesArray(pkg.services)); // ✅ FIX: ab string ya array dono se sahi parse hota hai
    resetPackageErrors();
    setSgcShowEdit(true);
  };

  const apmToggleService = (serviceId) => {
    setServices(prev =>
      prev.includes(serviceId)
        ? prev.filter(s => s !== serviceId)
        : [...prev, serviceId]
    );
  };

  /* ── Venue dropdown helper ── */
  // Agar backend se name field alag ho toh yahan adjust karo
  // e.g. v.venueName, v.venue_name, etc.
  const getVenueName = (v) => v.name || v.venueName || v.venue_name || '';

  const apmFiltered = useMemo(() => packages.filter(p => {
    const s = p.name?.toLowerCase().includes(apmSearch.toLowerCase());
    const t = apmStatus === 'All' || p.status === apmStatus;
    return s && t;
  }), [packages, apmSearch, apmStatus]);

  const apmTotalPages = Math.ceil(apmFiltered.length / APM_PER_PAGE) || 1;
  const apmPaginated  = apmFiltered.slice(
    (apmPage - 1) * APM_PER_PAGE,
    apmPage       * APM_PER_PAGE
  );

  const apmStats = useMemo(() => ({
    total:    packages.length,
    active:   packages.filter(p => p.status === 'Active').length,
    inactive: packages.filter(p => p.status === 'Inactive').length,
  }), [packages]);

  const apmReset = () => {
    setApmSearch(''); setApmStatus('All'); setApmPage(1);
  };

  /* ── Venue Dropdown (reusable JSX) ── */
  const VenueDropdown = ({ value, onChange }) => (
    <select className="apm-form-select" value={value} onChange={onChange}>
      <option value="">-- Select Venue --</option>
      {venues.map(v => (
        <option key={v.id ?? getVenueName(v)} value={getVenueName(v)}>
          {getVenueName(v)}
        </option>
      ))}
    </select>
  );

  return (
    <AdminLayout>
    <div className="apm-wrapper">

      {/* Page Header */}
      <div className="apm-page-header-new">
        <h1 className="apm-page-title-new">
          <div className="apm-title-icon-box">📦</div>
          Manage Packages
        </h1>
        <p className="apm-page-subtitle-new">
          Create and manage wedding packages for customers
        </p>
      </div>

      {/* Stats */}
      <div className="apm-stats apm-stats--three">
        <div className="apm-stat-card apm-stat-card--indigo">
          <div className="apm-stat-icon">📦</div>
          <div className="apm-stat-info">
            <div className="apm-stat-value">{apmStats.total}</div>
            <div className="apm-stat-label">Total Packages</div>
          </div>
        </div>
        <div className="apm-stat-card apm-stat-card--green">
          <div className="apm-stat-icon">✅</div>
          <div className="apm-stat-info">
            <div className="apm-stat-value">{apmStats.active}</div>
            <div className="apm-stat-label">Active</div>
          </div>
        </div>
        <div className="apm-stat-card apm-stat-card--purple">
          <div className="apm-stat-icon">🚫</div>
          <div className="apm-stat-info">
            <div className="apm-stat-value">{apmStats.inactive}</div>
            <div className="apm-stat-label">Inactive</div>
          </div>
        </div>
      </div>

      {/* Action Bar */}
      <div className="apm-action-bar">
        <div className="apm-search-wrap">
          <span className="apm-search-icon">🔍</span>
          <input type="text" className="apm-search-input"
            placeholder="Search packages by name..."
            value={apmSearch}
            onChange={e => { setApmSearch(e.target.value); setApmPage(1); }}
          />
        </div>
        <select className="apm-filter-select" value={apmStatus}
          onChange={e => { setApmStatus(e.target.value); setApmPage(1); }}>
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
        <div className="apm-action-bar-right">
          <button className="apm-btn-reset" onClick={apmReset}>↺ Reset</button>
          <button className="apm-btn-add" onClick={handleAddPackageClick} disabled={addBtnLoading}>
            {addBtnLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Loading...
              </>
            ) : (
              '＋ Add New Package'
            )}
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="apm-table-card">
        <div className="apm-table-header">
          <h3 className="apm-table-title">📦 All Packages</h3>
          <span className="apm-table-count">{apmFiltered.length} packages</span>
        </div>

        <div className="apm-table-wrap">
          {pageLoading ? (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              Loading...
            </div>
          ) : (
            <table className="apm-table">
              <thead className="apm-thead">
                <tr>
                  <th>#</th>
                  <th>Package Name</th>
                  <th>Venue</th>
                  <th>Price (PKR)</th>
                  <th>Discount</th>
                  <th>Package Price</th>
                  <th>Capacity</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="apm-tbody">
                {apmPaginated.length > 0 ? apmPaginated.map((pkg, i) => (
                  <tr key={pkg.id}>
                    <td><span className="apm-serial">{(apmPage - 1) * APM_PER_PAGE + i + 1}</span></td>
                    <td className="apm-pkg-name-cell">
                      <span className="apm-pkg-name-text">{pkg.name}</span>
                    </td>
                    <td><span className="apm-venue-text">{pkg.venue || '—'}</span></td>
                    <td><span className="apm-price-text">PKR {formatCurrency(pkg.price)}</span></td>
                    <td><span className="apm-discount-text">{pkg.discount ? `${pkg.discount}%` : '—'}</span></td>
                    <td><span className="apm-package-price-text">PKR {formatCurrency(pkg.packagePrice || pkg.price)}</span></td>
                    <td><span className="apm-capacity-text">👥 {pkg.capacity}</span></td>
                    <td>
                      <span className={`apm-status-badge apm-status-badge--${pkg.status?.toLowerCase()}`}>
                        <span className="apm-status-dot" />
                        {pkg.status}
                      </span>
                    </td>
                    <td>
                      <div className="apm-actions">
                        <button className="apm-btn-view apm-btn-icon-only"
                          onClick={() => { setSgcViewData(pkg); setSgcShowView(true); }} title="View">👁</button>
                        <button className="apm-btn-edit apm-btn-icon-only"
                          onClick={() => sgcOpenEdit(pkg)} title="Edit">✏️</button>
                        <button className="apm-btn-delete apm-btn-icon-only"
                          onClick={() => setApmDeleteId(pkg.id)} title="Delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="9">
                      <div className="apm-empty">
                        <span className="apm-empty-icon">📭</span>
                        <p className="apm-empty-text">No packages found.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        <div className="apm-pagination">
          <span className="apm-pagination-info">
            Showing <span>{apmFiltered.length === 0 ? 0 : (apmPage - 1) * APM_PER_PAGE + 1}</span>–
            <span>{Math.min(apmPage * APM_PER_PAGE, apmFiltered.length)}</span> of <span>{apmFiltered.length}</span> packages
          </span>
          {apmTotalPages > 1 && (
            <div className="apm-page-btns">
              <button className="apm-page-btn" onClick={() => setApmPage(1)}           disabled={apmPage === 1}>«</button>
              <button className="apm-page-btn" onClick={() => setApmPage(p => p - 1)} disabled={apmPage === 1}>‹</button>
              {Array.from({ length: apmTotalPages }, (_, i) => i + 1).map(p => (
                <button key={p} className={`apm-page-btn ${apmPage === p ? 'apm-page-btn--active' : ''}`}
                  onClick={() => setApmPage(p)}>{p}</button>
              ))}
              <button className="apm-page-btn" onClick={() => setApmPage(p => p + 1)}   disabled={apmPage === apmTotalPages}>›</button>
              <button className="apm-page-btn" onClick={() => setApmPage(apmTotalPages)} disabled={apmPage === apmTotalPages}>»</button>
            </div>
          )}
        </div>
      </div>

      {/* ── ADD MODAL ── */}
      {sgcShowAdd && (
        <div className="apm-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="apm-modal apm-modal-large" onClick={e => e.stopPropagation()}>
            <div className="apm-modal-head">
              <p className="apm-modal-head-label">New Package</p>
              <h2 className="apm-modal-head-title">📦 Add New Package</h2>
              <button className="apm-modal-close" onClick={() => setSgcShowAdd(false)}>✕</button>
            </div>
            <div className="apm-modal-body">
              <div className="apm-form-grid">
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Package Name <span>*</span></label>
                  <input type="text" className={`apm-form-input ${packageErrors.name ? 'input-error' : ''}`}
                    placeholder="e.g. Full Service Package"
                    value={Name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setPackageErrors({
                        ...packageErrors,
                        name: e.target.value.trim() ? regexChecker('eventName', e.target.value) : 'Package Name is required'
                      });
                    }} />
                  {packageErrors.name && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.name}</p>
                  )}
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Venue</label>
                  {/* ← Ab backend se aane wali venues */}
                  <VenueDropdown value={Venue} onChange={(e) => setVenue(e.target.value)} />
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Capacity</label>
                  <input type="text" className="apm-form-input" placeholder="e.g. 200–300 guests"
                    value={Capacity} onChange={(e) => setCapacity(e.target.value)} />
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Original Price (PKR) <span>*</span></label>
                  <input type="text" className={`apm-form-input ${packageErrors.price ? 'input-error' : ''}`}
                    placeholder="e.g. 150000"
                    value={Price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      setPackageErrors({
                        ...packageErrors,
                        price: e.target.value ? regexChecker('budget', e.target.value) : 'Original Price is required'
                      });
                    }} />
                  {packageErrors.price && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.price}</p>
                  )}
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Discount (%)</label>
                  <input type="text" className={`apm-form-input ${packageErrors.discount ? 'input-error' : ''}`}
                    placeholder="e.g. 10"
                    value={Discount}
                    onChange={(e) => {
                      setDiscount(e.target.value);
                      setPackageErrors({ ...packageErrors, discount: regexChecker('budget', e.target.value) });
                    }} />
                  {packageErrors.discount && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.discount}</p>
                  )}
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Package Price (After Discount) — Auto-calculated</label>
                  <input type="text" className="apm-form-input" readOnly
                    placeholder="Original Price aur Discount se khud ban jayegi"
                    value={PackagePrice ? formatCurrency(PackagePrice) : ''} />
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Description</label>
                  <textarea className="apm-form-textarea" placeholder="Brief description..."
                    value={Description} onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Features (comma separated)</label>
                  <input type="text" className="apm-form-input" placeholder="Timeline Creation, Catering..."
                    value={Features} onChange={(e) => setFeatures(e.target.value)} />
                </div>
              </div>

              <div className="apm-services-section">
                <label className="apm-form-label" style={{ display:'block', marginBottom:'12px' }}>
                  🎯 Available Services
                </label>
                <p style={{ fontSize:'12px', color:'#64748b', marginBottom:'14px' }}>
                  Select the services available in this package
                </p>
                <div className="apm-services-grid">
                  {APM_SERVICES.map(service => (
                    <label key={service.id} className="apm-service-checkbox">
                      <input type="checkbox"
                        checked={Services.includes(service.id)}
                        onChange={() => apmToggleService(service.id)} />
                      <span className="apm-service-icon">{service.icon}</span>
                      <span className="apm-service-label">{service.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom:'16px', marginTop:'20px' }}>
                <label className="apm-form-label" style={{ display:'block', marginBottom:'8px' }}>Status</label>
                <div className="apm-toggle-group">
                  {['Active', 'Inactive'].map(v => (
                    <label key={v} className="apm-toggle-label">
                      <input type="radio" name="apm-status-add" value={v}
                        checked={Status === v}
                        onChange={() => setStatus(v)} />
                      {v === 'Active' ? '✅ Active' : '🚫 Inactive'}
                    </label>
                  ))}
                </div>
              </div>

              <div className="apm-modal-footer">
                <button className="apm-btn-cancel" onClick={() => setSgcShowAdd(false)}>Cancel</button>
                <button className="apm-btn-save" onClick={createPackage} disabled={isLoading}>
                  💾 {isLoading ? 'Saving...' : 'Save Package'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── EDIT MODAL ── */}
      {sgcShowEdit && (
        <div className="apm-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="apm-modal apm-modal-large" onClick={e => e.stopPropagation()}>
            <div className="apm-modal-head">
              <p className="apm-modal-head-label">Edit Package</p>
              <h2 className="apm-modal-head-title">✏️ Edit Package</h2>
              <button className="apm-modal-close" onClick={() => setSgcShowEdit(false)}>✕</button>
            </div>
            <div className="apm-modal-body">
              <div className="apm-form-grid">
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Package Name <span>*</span></label>
                  <input type="text" className={`apm-form-input ${packageErrors.name ? 'input-error' : ''}`}
                    placeholder="e.g. Full Service Package"
                    value={Name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setPackageErrors({
                        ...packageErrors,
                        name: e.target.value.trim() ? regexChecker('eventName', e.target.value) : 'Package Name is required'
                      });
                    }} />
                  {packageErrors.name && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.name}</p>
                  )}
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Venue</label>
                  {/* ← Ab backend se aane wali venues */}
                  <VenueDropdown value={Venue} onChange={(e) => setVenue(e.target.value)} />
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Capacity</label>
                  <input type="text" className="apm-form-input" placeholder="e.g. 200–300 guests"
                    value={Capacity} onChange={(e) => setCapacity(e.target.value)} />
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Original Price (PKR) <span>*</span></label>
                  <input type="text" className={`apm-form-input ${packageErrors.price ? 'input-error' : ''}`}
                    placeholder="e.g. 150000"
                    value={Price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      setPackageErrors({
                        ...packageErrors,
                        price: e.target.value ? regexChecker('budget', e.target.value) : 'Original Price is required'
                      });
                    }} />
                  {packageErrors.price && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.price}</p>
                  )}
                </div>
                <div className="apm-form-group">
                  <label className="apm-form-label">Discount (%)</label>
                  <input type="text" className={`apm-form-input ${packageErrors.discount ? 'input-error' : ''}`}
                    placeholder="e.g. 10"
                    value={Discount}
                    onChange={(e) => {
                      setDiscount(e.target.value);
                      setPackageErrors({ ...packageErrors, discount: regexChecker('budget', e.target.value) });
                    }} />
                  {packageErrors.discount && (
                    <p style={{ color: 'red', fontSize: '13px' }}>{packageErrors.discount}</p>
                  )}
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Package Price (After Discount) — Auto-calculated</label>
                  <input type="text" className="apm-form-input" readOnly
                    placeholder="Original Price aur Discount se khud ban jayegi"
                    value={PackagePrice ? formatCurrency(PackagePrice) : ''} />
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Description</label>
                  <textarea className="apm-form-textarea" placeholder="Brief description..."
                    value={Description} onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div className="apm-form-group apm-form-group--full">
                  <label className="apm-form-label">Features (comma separated)</label>
                  <input type="text" className="apm-form-input" placeholder="Timeline Creation, Catering..."
                    value={Features} onChange={(e) => setFeatures(e.target.value)} />
                </div>
              </div>

              <div className="apm-services-section">
                <label className="apm-form-label" style={{ display:'block', marginBottom:'12px' }}>
                  🎯 Available Services
                </label>
                <div className="apm-services-grid">
                  {APM_SERVICES.map(service => (
                    <label key={service.id} className="apm-service-checkbox">
                      <input type="checkbox"
                        checked={Services.includes(service.id)}
                        onChange={() => apmToggleService(service.id)} />
                      <span className="apm-service-icon">{service.icon}</span>
                      <span className="apm-service-label">{service.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom:'16px', marginTop:'20px' }}>
                <label className="apm-form-label" style={{ display:'block', marginBottom:'8px' }}>Status</label>
                <div className="apm-toggle-group">
                  {['Active', 'Inactive'].map(v => (
                    <label key={v} className="apm-toggle-label">
                      <input type="radio" name="apm-status-edit" value={v}
                        checked={Status === v}
                        onChange={() => setStatus(v)} />
                      {v === 'Active' ? '✅ Active' : '🚫 Inactive'}
                    </label>
                  ))}
                </div>
              </div>

              <div className="apm-modal-footer">
                <button className="apm-btn-cancel" onClick={() => setSgcShowEdit(false)}>Cancel</button>
                <button className="apm-btn-save" onClick={updatePackage} disabled={isLoading}>
                  💾 {isLoading ? 'Updating...' : 'Update Package'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── VIEW MODAL ── */}
      {sgcShowView && (() => {
        const viewFeatures = toFeaturesArray(sgcViewData.features);
        const viewServices = toServicesArray(sgcViewData.services); // ✅ FIX
        return (
          <div className="apm-overlay" onClick={() => setSgcShowView(false)}>
            <div className="apm-modal apm-view-modal" onClick={e => e.stopPropagation()}>
              <div className="apm-modal-head">
                <p className="apm-modal-head-label">Package Details</p>
                <h2 className="apm-modal-head-title">📦 {sgcViewData.name}</h2>
                <button className="apm-modal-close" onClick={() => setSgcShowView(false)}>✕</button>
              </div>
              <div className="apm-view-body">
                <div className="apm-view-grid">
                  <div className="apm-view-item">
                    <div className="apm-view-label">Venue</div>
                    <div className="apm-view-value">{sgcViewData.venue || '—'}</div>
                  </div>
                  <div className="apm-view-item">
                    <div className="apm-view-label">Capacity</div>
                    <div className="apm-view-value">👥 {sgcViewData.capacity}</div>
                  </div>
                  <div className="apm-view-item">
                    <div className="apm-view-label">Original Price</div>
                    <div className="apm-view-value" style={{ color:'#7c3aed' }}>PKR {formatCurrency(sgcViewData.price)}</div>
                  </div>
                  <div className="apm-view-item">
                    <div className="apm-view-label">Discount</div>
                    <div className="apm-view-value">{sgcViewData.discount ? `${sgcViewData.discount}%` : '—'}</div>
                  </div>
                  <div className="apm-view-item">
                    <div className="apm-view-label">Package Price</div>
                    <div className="apm-view-value" style={{ color:'#10b981', fontWeight:'800' }}>
                      PKR {formatCurrency(sgcViewData.packagePrice || sgcViewData.price)}
                    </div>
                  </div>
                  <div className="apm-view-item">
                    <div className="apm-view-label">Status</div>
                    <div className="apm-view-value">{sgcViewData.status === 'Active' ? '✅ Active' : '🚫 Inactive'}</div>
                  </div>
                  <div className="apm-view-item apm-view-item--full">
                    <div className="apm-view-label">Description</div>
                    <div className="apm-view-value">{sgcViewData.description}</div>
                  </div>
                  {viewFeatures.length > 0 && (
                    <div className="apm-view-item apm-view-item--full">
                      <div className="apm-view-label">Features</div>
                      <ul className="apm-view-features">
                        {viewFeatures.map((f, i) => (
                          <li key={i} className="apm-view-feature">
                            <span className="apm-view-check">✅</span> {f}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {viewServices.length > 0 && (
                    <div className="apm-view-item apm-view-item--full">
                      <div className="apm-view-label">Available Services</div>
                      <div className="apm-services-badges">
                        {viewServices.map(sId => {
                          const service = APM_SERVICES.find(s => s.id === sId);
                          return service ? (
                            <span key={sId} className="apm-service-badge">
                              {service.icon} {service.label}
                            </span>
                          ) : null;
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="apm-modal-footer">
                  <button className="apm-btn-cancel" onClick={() => setSgcShowView(false)}>Close</button>
                  <button className="apm-btn-save"
                    onClick={() => { setSgcShowView(false); sgcOpenEdit(sgcViewData); }}>✏️ Edit Package</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── DELETE CONFIRM MODAL ── */}
      {apmDeleteId !== null && (
        <div className="apm-overlay" onClick={() => setApmDeleteId(null)}>
          <div className="apm-modal apm-delete-modal" onClick={e => e.stopPropagation()}>
            <div className="apm-modal-head apm-modal-head--red">
              <p className="apm-modal-head-label">Confirm Action</p>
              <h2 className="apm-modal-head-title">🗑️ Delete Package</h2>
              <button className="apm-modal-close" onClick={() => setApmDeleteId(null)}>✕</button>
            </div>
            <div className="apm-delete-body">
              <span className="apm-delete-icon">🗑️</span>
              <h3 className="apm-delete-title">Are you sure?</h3>
              <p className="apm-delete-text">
                This package <strong>will be permanently deleted.</strong><br />
                This action cannot be undone!
              </p>
              <div className="apm-delete-btns">
                <button className="apm-btn-no"          onClick={() => setApmDeleteId(null)}>No, Cancel</button>
                <button className="apm-btn-confirm-del" onClick={() => deletePackage(apmDeleteId)}>🗑️ Yes, Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
    </AdminLayout>
  );
};

export default ManagePackages;